import { ErrorString, InvalidOperationException } from "../../shared/index.js";
export const lastAsync = async (source, predicate) => {
    let last = null;
    for await (const value of source) {
        if (await predicate(value) === true) {
            last = value;
        }
    }
    if (!last) {
        throw new InvalidOperationException(ErrorString.NoMatch);
    }
    return last;
};
